/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".form-control[_ngcontent-%COMP%]{padding:24px 0!important;border:2px solid #c2cad8!important;text-align:center}.form-control[_ngcontent-%COMP%], output[_ngcontent-%COMP%]{font-size:20px!important;font-weight:600!important}"];
export { styles as styles };

